module.exports = require('./helpers/bundle-url').getBundleURL('jtuNe') + "logo.c51670a8.svg";